module.exports = __webpack_public_path__ + "img/AccessTimeFilledOutlined.ae684e80.svg";